import axios from 'axios';
export default (corpId, creds) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .post(`${process.env.VUE_APP_API_ADMIN_LOCATION}organizations/${corpId}/admins`, creds.payload)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
